
export const PhoneFormatter = (phone:any) => {
    let value;
      let temp = phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      if (temp) {
        value = !temp[2] ? temp[1] : + temp[1] + '-' + temp[2] + (temp[3] ? '-' + temp[3] : '');
      }
      return value
  };